import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';
import { environment } from '../environments/environment';
import { setAppInjector } from './app-injector';
import { AppConfigService } from './services/app-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(
    private eRef: ElementRef,
    private vcr: ViewContainerRef,
    private renderer2: Renderer2,
    private configService: AppConfigService,
    @Inject(DOCUMENT) private document: Document
  ) {
    setTheme('bs5');
    const element: HTMLElement = this.eRef.nativeElement;
    const claveMaps = element.getAttribute('clave-maps');
    if (claveMaps) {
      environment.claveMaps = claveMaps;
    }

    const offline = element.getAttribute('offline');
    if (offline) {
      environment.offline = offline === 'true';
    }

    const gaId = element.getAttribute('ga-id');
    if (gaId) {
      environment.googleAnalyticsId = gaId;
    }
    const cookiesScript = element.getAttribute('cookies-script');
    if (cookiesScript) {
      environment.cookiesScript = cookiesScript;
    }
    if (environment.cookiesScript) {
      this.inyectCookiesScript();
    } else {
      environment.useCookies = false;
    }
    let textosTiempoOffline: any = element.getAttribute(
      'textos-tiempo-offline'
    );
    if (textosTiempoOffline) {
      textosTiempoOffline = JSON.parse(textosTiempoOffline);
      environment.textosTiempoOffline = textosTiempoOffline;
    }

    if (this.configService.appConfiguration?.warning?.titleWarning) {
      JSON.parse(this.configService.appConfiguration?.warning?.titleWarning);
      this.configService.appConfiguration?.warning?.titleWarning;
    }

    if (this.configService.appConfiguration?.warning?.textWarning) {
      JSON.parse(this.configService.appConfiguration?.warning?.textWarning);
      this.configService.appConfiguration?.warning?.textWarning;
    }

    if (this.configService.appConfiguration?.warning?.startDateWarning) {
      this.configService.appConfiguration?.warning?.startDateWarning;
    }

    if (this.configService.appConfiguration?.warning?.endDateWarning) {
      this.configService.appConfiguration?.warning?.endDateWarning;
    }
    setAppInjector(this.vcr.injector);
  }
  title = 'rs';
  inyectCookiesScript() {
    if (environment.useCookies) {
      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.charset = 'UTF-8';
      const scriptKey = environment.cookiesScript;
      script.setAttribute('data-domain-script', scriptKey);
      script.setAttribute('data-document-language', 'true');
      this.renderer2.appendChild(this.document.head, script);
      const script2 = this.renderer2.createElement('script');
      script2.type = 'text/javascript';
      script2.innerHTML = `function OptanonWrapper() {}`;
      this.renderer2.appendChild(this.document.head, script2);
    }
  }
}
